import { styled } from '@mui/material/styles';

export const CarouselRoot = styled('div', {
    name: 'Carousel',
    slot: 'root',
    skipSx: false,
})(() => ({
    maxWidth: '100%',
    margin: 'auto',
    position: 'relative',
    '--slide-height': '19rem',
    '--slide-spacing': '1rem',
    '--slide-size': '100%',
    '--carousel-slide-shadow': 'inset 0 0 0 0.2rem var(--mui-palette-divider)',
    '--carousel-dot-shadow': 'inset 0 0 0 0.2rem var(--mui-palette-divider)',
    '--carousel-dot-shadow-active': 'inset 0 0 0 0.2rem var(--mui-palette-text-primary)',
    '--carousel-arrow-color': 'var(--mui-palette-text-primary)',
    '--carousel-arrow-disabled': 'var(--mui-palette-action-disabled)',
}));
